// extracted by mini-css-extract-plugin
export default {"selected":"f2e5bbd734","un":"_54a67e3324"};